import React from "react";
import Heading from "../../components/Heading";
import ecomcategoriesModel from "../../models/vendorcollection.model";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { useState } from "react";
import helper from "../../lib/helper";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import autoComplete from "../../lib/autoComplete";
import productsModel from "../../models/products.model";

const Page = function () {
  const router = useRouter();
  const [selectedCategory, setSelectedCategory] = useState();
  const [category, setCategory] = useState([]);
  const [items, setItems] = useState([]);
  const queryParams = router.query;

  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    setError,
  } = useForm();

  const { register: handleRegister, handleSubmit: handleFormSubmit } =
    useForm();

  const handleChange = async (event) => {
    setSelectedCategory(event?.id);
    await ecomcategoriesModel.show(event?.id).then((res) => {
      setCategory(res.data);
    });
    //console.log(selectedCategory);
  };

  const onSubmit = handleSubmit(async (data, event) => {
    const formData = new FormData(event.target);
    // formData.set("content", editorRef.current.getContent());
    await productsModel
      .bulkupdate(selectedCategory, formData)
      .then((response) => {
        helper.sweetalert.toast(response?.data?.message, "success");
        // router.push("/products");
      })
      .catch((error) => {
        console.log(error.response?.data?.errors);
        helper.sweetalert.toast(error.response?.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  return (
    <>
      <Heading title="Bulk-update"></Heading>
      <div className="row container-fluid">
        <div className="col-md-6">
          {/*  <form onSubmit={onSubmit} className="container-fluid">
                        <div className="col-md-12">
                            <label className="form-label">Download-link</label>
                            <AsyncSelect
                                name={`category_id`}
                                onChange={handleChange}
                                defaultOptions
                                loadOptions={autoComplete.filterCategory}
                                placeholder='Search here...'
                                isClearable
                                id="download_select"
                            />
                        </div>
                        {category?.download_url &&
                            <a href={category?.download_url} download={category?.download_url} className="btn btn-sm btn-primary float-end mt-1">Download File</a>
                        }
                    <a href="/product_sample_file.xlsx" download="product_sample_file.xlsx" className="btn btn-sm btn-primary float-end mt-1">Download File</a>
                    </form> */}
        </div>
        <div className="col-md-6 mt-5 mt-md-0">
          <form onSubmit={onSubmit} className="container-fluid">
            <div className="col-md-12">
              <label className="form-label">Ecom-category</label>
              <AsyncSelect
                name={`category_id`}
                onChange={handleChange}
                defaultOptions
                loadOptions={autoComplete.filterCategory}
                placeholder="Search here..."
                isClearable
                id="upload_select"
              />
            </div>
            <div className="col-md-6 mt-1">
              <input type="file" {...register("product")} />
            </div>
            <button
              disabled={isSubmitting ? "disabled" : ""}
              type="submit"
              className="btn btn-sm btn-primary float-end mt-1"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Page;
